<template>
    <div style="height: 100%; flex-basis: 100%;">
        <Signature
            title="Assinatura Vistoriador"
            type="inspector"
            :initial-points="initialInspectorSignature"
            ref="signature"
        />

        <div class="container-buttons">
            <b-button
                class="mt-3 buttons"
                variant="danger"
                type="button"
                id="clear-button"
                @click="clear"
            >
                <img src="@/assets/quizIcons/ic_apagar2.png" width="18" height="18" />
                Limpar</b-button
            >
            <b-button
                class="mt-3 buttons"
                variant="success"
                type="button"
                id="save-button"
                @click.stop="nextPhase"
                >Próximo</b-button
            >
        </div>
    </div>

    
</template>

<script>
import { BButton } from "bootstrap-vue";

import Signature from "@/components/Signature.vue";

export default {
    name: "InspectorSignature",
    components: {
        Signature,
        BButton
    },
    data: function () {
        return {
            initialInspectorSignature: null
        };
    },
    created: function () {
        this.initialInspectorSignature = this.$store.state.inspectionData.inspectorSignaturePoints;
    },
    methods: {
        clear() {
            this.$refs.signature.clearCanvas();
        },
        //saveSignature: function (signatureType) {
        //    let signature = this.$refs.signature;
        //    signature.saveSignature(signatureType);
        //},
        saveSignature: async function () {
            let signature = this.$refs.signature;
            const { signaturePoints, signatureURL } = signature.captureSignature();

            //If there is signaturePoints, the user draw something on the signature phase.
            if (signaturePoints[0] && signaturePoints[0].points.length > 0) {
                this.$store.commit("setInspectorSigComplete", true);
                this.$store.commit("setInspectorSignaturePoints", signaturePoints);

                const inspectorSignature = {
                    image_base64: signatureURL,
                    image_name: "Vistoriador",
                };

                const signatures = this.$store.state.inspectionData.signatures;
                signatures.forEach((item, index, object) => {
                    if (item.image_name === "Vistoriador") {
                        object.splice(index, 1);
                    }
                });

                this.$store.commit("setSignature", inspectorSignature);
            } else {
                this.$store.commit("setInspectorSignaturePoints", null);
                this.$store.commit("setInspectorSigComplete", false);
            }
        },

        nextPhase: function () {
            this.$router.push("/inspection/client-signature");
        },
    },
    async beforeRouteLeave(to, from, next) {
        try {
            this.saveSignature();
        } catch (error) {
            console.error("Erro ao salvar assinatura:", error);
        }
        next();
    },
};
</script>

<style scoped>

    .container-buttons {
        background: linear-gradient(#cdd7d6, white);
        width: 100%;
        position: fixed;
        bottom: 0;
        padding-left: 7%;
        padding-right: 7%;
        padding-bottom: 10px;
        right: 0;
        display: flex;
        justify-content: space-between;
    }

    .buttons {
        float: right;
        width: 100px;
        margin-right: 0;
    }
</style>
